import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-phimtat',
  templateUrl: './dialog-phimtat.component.html',
  styleUrl: './dialog-phimtat.component.scss'
})
export class DialogPhimtatComponent {

}
